import { useMemo } from 'react';
import {
  GridColDef,
  GridSlotsComponentsProps,
  GridValidRowModel,
} from '@mui/x-data-grid-pro';
interface UseCommonDataGridSlotPropsOptions<T extends GridValidRowModel> {
  columns: GridColDef<T>[];
}

export function useCommonDataGridSlotProps<T extends GridValidRowModel>({
  columns,
}: UseCommonDataGridSlotPropsOptions<T>): GridSlotsComponentsProps {
  return useMemo(
    () => ({
      columnsManagement: {
        disableShowHideToggle: false,
        disableResetButton: true,
        getTogglableColumns: () => columns.map((column) => column.field),
      },
      loadingOverlay: {
        variant: 'skeleton',
        noRowsVariant: 'skeleton',
      },
      basePopper: {
        placement: 'bottom-end',
      },
      baseTextField: { variant: 'outlined', size: 'small' },
      baseSelect: { variant: 'outlined', size: 'small' },
    }),
    [columns]
  );
}

